import { useMemo, useState } from "react";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { filterTags, highlights } from "@/mocks/homeContent";

export default function HighlightSection() {
  const [active, setActive] = useState("全部");

  const list = useMemo(() => {
    if (active === "全部") return highlights;
    return highlights.filter((item) => item.tag === active);
  }, [active]);

  return (
    <section id="highlights" className="scroll-mt-24 bg-background-100">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="内容看点"
          title="值得留意的几处细节"
          desc="用标签快速筛选你关心的方向：剧情结构、人物塑造、氛围营造、情感表达与现实质感，各有对应条目。"
        />

        <div className="mt-8 flex flex-wrap gap-2">
          {filterTags.map((tag) => {
            const isActive = tag === active;
            return (
              <button
                key={tag}
                type="button"
                onClick={() => setActive(tag)}
                aria-pressed={isActive}
                className={
                  "cursor-pointer whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors " +
                  (isActive
                    ? "bg-primary-500 text-background-50"
                    : "border border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-800")
                }
              >
                {tag}
              </button>
            );
          })}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:gap-5">
          {list.map((item) => (
            <article
              key={item.title}
              className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <div className="flex items-center justify-between gap-2">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-lg text-accent-700">
                  <i className={item.icon}></i>
                </span>
                <span className="whitespace-nowrap rounded-full bg-background-200 px-2.5 py-0.5 text-xs text-foreground-700">
                  {item.tag}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-sm font-semibold text-foreground-950 md:text-base">
                {item.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                {item.desc}
              </p>
            </article>
          ))}
        </div>

        {list.length === 0 && (
          <p className="mt-8 rounded-lg border border-background-300 bg-background-50 p-6 text-center text-sm text-foreground-600">
            该分类下暂无条目，试试其他标签。
          </p>
        )}
      </div>
    </section>
  );
}